import './App.css';

import { BrowserRouter, Routes, Route } from "react-router-dom";

import NavBar from "./components/NavBar.jsx";
import Footer from "./components/Footer.jsx";
import Hero from "./blocks/Hero.jsx";
import Benefits from "./blocks/Benefits.jsx";
import ContactForm from "./components/ContactForm.jsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.jsx";
import TermsOfService from "./pages/TermsOfService.jsx";
import ContactSupport from "./pages/ContactSupport.jsx";

function HomePage() {
  return (
    <section className="py-3 page">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <Hero />
            <Benefits />
          </div>
          <div className="col-lg-4 col-contact">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
}

function App() {
  return (
  <BrowserRouter>
    <div className="App">
      <NavBar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/contact-support" element={<ContactSupport />} />
        </Routes>
      </main>
      <Footer />
    </div>
  </BrowserRouter>
  );
}

export default App;
